// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modal dialogs */
.modal-header {
  font-family: "Open Sans", Arial, sans-serif;
  border-bottom: 1px solid #DAE2E8;
  border-radius: 0;
}

.modal-body {
  min-height: 90px;
  background-color: #e9f1f5;
  padding: 20px;
  margin-left: 1px;
}

.modal-header .close {
  margin-top: 0px;
  opacity: 0.8;
  color: #afc1cf;
  padding: 0rem;
  margin: 0rem 0rem 0rem auto;
}

.modal-title {
  font-family: "Open Sans", Arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  color: #404040;
  margin-left: 5px;
}

.modal-header .close:hover, .modal-header .close:focus {
  opacity: 1;
  color: #afc1cf;
}

.modal-footer {
  padding: 12px 8px;
  border-top: solid 1px #d0d5d9;
}

/* error message */
.b-error .modal-header {
  border-bottom: solid 1px #fa3f40;
}

.b-error .ib-alert {
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

/* warning message */
.b-warning .modal-header {
  border-bottom: solid 1px #f15d22;
}

.b-warning .ib-warning {
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

/* info message */
.b-info .modal-header {
  border-bottom: solid 1px #43acd9;
}

.b-info .ib-info {
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

.icon-Close {
  font-family: "icomoon" !important;
  font-weight: lighter;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #93A4AA;
}

::ng-deep .wfm-modal .modal-content create-plan {
  border-radius: 0;
  min-height: 521px;
  width: 540px;
  border: 1px solid #DAE2E8;
}
::ng-deep .wfm-modal .modal-header {
  height: 80px;
  align-items: center;
  border-bottom: 1px solid #DAE2E8;
}
::ng-deep .wfm-modal .modal-footer {
  height: 80px;
  border-top: solid 1px #d0d5d9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/create-plan/create-plan.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/components/create-plan/create-plan.component.scss"],"names":[],"mappings":"AAAA,kBAAA;AAUA;EAEE,2CAAA;EACA,gCAAA;EACA,gBAAA;ACTF;;ADYA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;ACTF;;ADaA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;ACVF;;ADcA;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;ACXF;;ADcA;EACE,UAAA;EACA,cAAA;ACXF;;ADqBA;EACE,iBAAA;EACA,6BAAA;AClBF;;ADqBA,kBAAA;AACA;EACE,gCAAA;AClBF;;ADqBA;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;AClBF;;ADqBA,oBAAA;AACA;EACE,gCAAA;AClBF;;ADqBA;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;AClBF;;ADqBA,iBAAA;AACA;EACE,gCAAA;AClBF;;ADqBA;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;AClBF;;ADqBA;EACE,iCAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;EACA,cAAA;AClBF;;ADuBE;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;ACpBJ;ADuBE;EACE,YAAA;EACA,mBAAA;EACA,gCAAA;ACrBJ;ADwBE;EACE,YAAA;EACA,6BAAA;ACtBJ","sourcesContent":["/* modal dialogs */\n\n\n// :host ::ng-deep .modal-content{\n//     border-radius: 0;\n//     height: 511px;\n//     width: 540px;\n//     border: 1px solid #DAE2E8;\n// }\n\n.modal-header {\n  // padding: 12px 20px 11px 20px;\n  font-family: \"Open Sans\", Arial, sans-serif;\n  border-bottom: 1px solid #DAE2E8;\n  border-radius: 0;\n}\n\n.modal-body {\n  min-height: 90px;\n  background-color: #e9f1f5;\n  padding: 20px;\n  margin-left: 1px;\n\n}\n\n.modal-header .close {\n  margin-top: 0px;\n  opacity: .8;\n  color: #afc1cf;\n  padding: 0rem;\n  margin: 0rem 0rem 0rem auto;\n\n}\n\n.modal-title {\n  font-family: \"Open Sans\", Arial, sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  color: #404040;\n  margin-left: 5px;\n}\n\n.modal-header .close:hover, .modal-header .close:focus {\n  opacity: 1;\n  color: #afc1cf;\n}\n\n// .modal-content {\n//     // border-radius: 0;\n//     max-width:420px;\n//     box-shadow:0 0 35px rgba(0,0,0,.3);\n//     border:solid 1px #d0d5d9;\n//     border-radius: 0;\n// }\n.modal-footer {\n  padding: 12px 8px;\n  border-top: solid 1px #d0d5d9;\n}\n\n/* error message */\n.b-error .modal-header {\n  border-bottom: solid 1px #fa3f40;\n}\n\n.b-error .ib-alert {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n/* warning message */\n.b-warning .modal-header {\n  border-bottom: solid 1px #f15d22;\n}\n\n.b-warning .ib-warning {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n/* info message */\n.b-info .modal-header {\n  border-bottom: solid 1px #43acd9;\n}\n\n.b-info .ib-info {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.icon-Close {\n  font-family: 'icomoon' !important;\n  font-weight: lighter;\n  -webkit-font-smoothing: antialiased;\n  font-size: 16px;\n  color: #93A4AA;\n\n}\n\n::ng-deep .wfm-modal {\n  .modal-content create-plan{\n    border-radius: 0;\n    min-height: 521px;\n    width: 540px;\n    border: 1px solid #DAE2E8;\n  }\n\n  .modal-header {\n    height: 80px;\n    align-items: center;\n    border-bottom: 1px solid #DAE2E8;\n  }\n\n  .modal-footer {\n    height: 80px;\n    border-top: solid 1px #d0d5d9;\n  }\n\n}\n","/* modal dialogs */\n.modal-header {\n  font-family: \"Open Sans\", Arial, sans-serif;\n  border-bottom: 1px solid #DAE2E8;\n  border-radius: 0;\n}\n\n.modal-body {\n  min-height: 90px;\n  background-color: #e9f1f5;\n  padding: 20px;\n  margin-left: 1px;\n}\n\n.modal-header .close {\n  margin-top: 0px;\n  opacity: 0.8;\n  color: #afc1cf;\n  padding: 0rem;\n  margin: 0rem 0rem 0rem auto;\n}\n\n.modal-title {\n  font-family: \"Open Sans\", Arial, sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  color: #404040;\n  margin-left: 5px;\n}\n\n.modal-header .close:hover, .modal-header .close:focus {\n  opacity: 1;\n  color: #afc1cf;\n}\n\n.modal-footer {\n  padding: 12px 8px;\n  border-top: solid 1px #d0d5d9;\n}\n\n/* error message */\n.b-error .modal-header {\n  border-bottom: solid 1px #fa3f40;\n}\n\n.b-error .ib-alert {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n/* warning message */\n.b-warning .modal-header {\n  border-bottom: solid 1px #f15d22;\n}\n\n.b-warning .ib-warning {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n/* info message */\n.b-info .modal-header {\n  border-bottom: solid 1px #43acd9;\n}\n\n.b-info .ib-info {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.icon-Close {\n  font-family: \"icomoon\" !important;\n  font-weight: lighter;\n  -webkit-font-smoothing: antialiased;\n  font-size: 16px;\n  color: #93A4AA;\n}\n\n::ng-deep .wfm-modal .modal-content create-plan {\n  border-radius: 0;\n  min-height: 521px;\n  width: 540px;\n  border: 1px solid #DAE2E8;\n}\n::ng-deep .wfm-modal .modal-header {\n  height: 80px;\n  align-items: center;\n  border-bottom: 1px solid #DAE2E8;\n}\n::ng-deep .wfm-modal .modal-footer {\n  height: 80px;\n  border-top: solid 1px #d0d5d9;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
